module.exports = __webpack_public_path__ + "img/花草_05.abf4caa0.png";